<template>
  <div class="row form-group">
    <div class="col-md-12">
      <base-input
        :placeholder="placeholder"
        class="input-group-alternative mb-3"
        v-model="cp"
        :addon-right-icon="icon"
      ></base-input>
    </div>
  </div>
</template>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";
export default {
  name: "postal-code-validator",
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "Ingresá tu CPA de 8 Dígitos"
    }
  },
  data() {
    return {
      cp: this.value,
      initialCp: this.value,
      cpChanged: false,
      icon: "",
      response: {
        isValid: false,
        provinceZipCode: {
          id: null,
          provinceID: null,
          provinceName: ""
        }
      }
    };
  },
  watch: {
    cp: function() {
      if (this.cp !== this.initialCp) {
        this.cpChanged = true;
      } else {
        this.cpChanged = false;
      }
      this.validateCp();
    },
    value(newValue) {
      if (newValue !== this.cp) {
        this.cp = newValue;
        this.initialCp = newValue;
      }
    }
  },
  methods: {
    emitCpValidated(context) {
      if (context.response.isValid) {
        context.icon = "fa fa-fw fa-check";
      } else {
        context.icon = "fa fa-fw fa-times";
      }

      context.$emit("cp-validated", context.response);
    },
    validateCp() {
      let context = this;

      if (!context.cpChanged) {
        context.response.isValid = true;
        context.emitCpValidated(context);
        return;
      }

      if (context.cp.length < 8) {
        context.response.isValid = false;
        context.emitCpValidated(context, false);
        return;
      }

      axiosHelpers.axiosGet(
        "Commerce/CheckZipCode",
        { ZipCode: context.cp },
        context,
        function(data) {
          context.response.isValid = data.ResponseVM.Success;
          context.response.provinceZipCode.id = data.ResponseVM.Province.EntityID;
          context.response.provinceZipCode.provinceID = data.ResponseVM.Province.ProvinceID;
          context.response.provinceZipCode.provinceName = data.ResponseVM.Province.Name;
          context.emitCpValidated(context);
          context.$emit("input", context.cp);
        }
      );
    }
  }
};
</script>